import { render } from "./LayerComponent.vue?vue&type=template&id=2477e408"
import script from "./LayerComponent.vue?vue&type=script&lang=js"
export * from "./LayerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__